export interface UserCharacteristics {
  sex: number; // 1 = male, 2 = female
  age: number;
  weight: number; // kilograms
  height: number; // centimeters
}

export enum Microenvironment {
  outdoors = 'Outdoors',
  vehicles = 'Inside vehicles',
  other = 'Indoors not at home',
  home = 'Indoors at home'
}

export type UserActivity = {
  [key in Microenvironment]: number;
}

export enum Intensity {
  sedentary = 'Sedentary',
  light = 'Light',
  moderate = 'Moderate',
  vigorous = 'Vigorous'
}

export type UserExercise = {
  [key in Microenvironment]: { [key in Intensity]: number };
}

export interface HomeCharacteristics {
  floorArea: number; // square meters
  yearBuilt: number;
  numberOfFloors: number; // 1-3 stories
  typeOfHouse: number; // 1 = single family, 2 = multi-family
  windShelteringOfHouse: number; // 1 = no nearby structures, 2 = isolated rural,
  // 3 = buildings across street, 4 = urban large lots,
  // 5 = closer than 1 building height
}

export interface HomeOperatingConditions {
  indoorTemperature: number; // degrees Celcius
  numberOfWindowsOpen: number;
  openingHeightOfWindows: number; // cm
  durationWindowsOpen: number; // hours
  numberOfDoorsOpen: number;
  openingHeightOfDoors: number; // cm
  durationDoorsOpen: number; // hours
  numberOfWindowFansOperating: number;
  durationWindowFansOperating: number; // hours
  airflowOfWindowFans: number; // cubic feet/min
  numberOfAirCleanersOperating: number;
  durationAirCleanersOperating: number; // hours
  cleanAirDeliveryRate: number; // cubic feet/min
}

export interface WeatherConditions {
  temperature: number; // degrees Celcius
  windSpeed: number; // km/hr
  humidity: number; // %
}

export interface AirPollution {
  outdoorPM25: number; // ug/m3
  outdoorOzone: number; // ppb
}

export interface InfiltrationParameters {
  penetrationCoefficientPM25Home: number;
  penetrationCoefficientOzoneHome: number;
  removalRatePM25Home: number; // 1/hr
  removalRateOzoneHome: number; // 1/hr
  infiltrationFactorPM25NotHomes: number;
  infiltrationFactorPM25Vehicles: number;
  infiltrationFactorOzoneNotHomes: number;
  infiltrationFactorOzoneVehicles: number;
}

export interface LocationOptions {
  mode: string;
  latitude: number;
  longitude: number;
  address: string;
}

export interface OtherConditions {
  indoorHomeHumidity: number; // %
  indoorNotHomeTemperature: number; // degrees Celcius
  indoorNotHomeHumidity: number; // %
  insideVehicleTemperature: number; // degrees Celcius
  insideVehicleHumidity: number; // %
}
